"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _reactQuery = require("react-query");

var _request = require("@nicbase/request");

var _nicbaseReducers = require("nicbase-reducers");

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var getFilterLookupValues = function getFilterLookupValues(portalId, filterAttribute, domain) {
  return {
    type: 'GET_FILTER_LOOKUP_VALUES_REQUEST',
    headers: {
      version: 'v1',
      portalId: portalId
    },
    body: {
      filterAttribute: filterAttribute,
      domain: domain
    }
  };
};

var useFilterLookupValues = function useFilterLookupValues(_ref) {
  var filterAttribute = _ref.filterAttribute,
      domain = _ref.domain,
      _ref$options = _ref.options,
      options = _ref$options === void 0 ? {} : _ref$options;

  var _useRequest = (0, _request.useRequest)(),
      request = _useRequest.request;

  var _usePortal = (0, _nicbaseReducers.usePortal)(),
      portalId = _usePortal.id;

  var query = (0, _reactQuery.useQuery)(['portal', portalId, 'filterLookupValues', {
    domain: domain,
    filterAttribute: filterAttribute
  }], /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    var _yield$request, filterOptions;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return request(getFilterLookupValues(portalId, filterAttribute, domain));

          case 2:
            _yield$request = _context.sent;
            filterOptions = _yield$request.body.filterOptions;
            return _context.abrupt("return", filterOptions);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), options);
  return query;
};

var _default = useFilterLookupValues;
exports["default"] = _default;